import { createSlice } from "@reduxjs/toolkit";
import { initialCreateState } from "../campaignDetails/campaignDetailers.initial-state";
import { createCampaign } from "../campaignDetails/campaignDetails.actions";

const createCampaignSlice = createSlice({
  name: "createCampaign",
  initialState: initialCreateState,
  reducers: {
    resetCreateState: () => initialCreateState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCampaign.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successId = null;
      })
      .addCase(createCampaign.fulfilled, (state, action) => {
        state.loading = false;
        state.successId = action.payload.id;
      })
      .addCase(createCampaign.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetCreateState } = createCampaignSlice.actions;
const createCampaignReducer = createCampaignSlice.reducer;
export default createCampaignReducer;
